export default function NodeInfoField(props: {
  label: string;
  value: string;
  action?: JSX.Element;
}) {
  return (
    <div
      className={
        "flex flex-col noDrag nowheel " +
        (props.label ? "gap-[8px]" : "")
      }
    >
      {props.label && (
        <div className="font-medium text-creator-text text-[14px]">
          {props.label}
        </div>
      )}
      <div className="flex w-full bg-creator-surface border-solid items-center border-creator-primary rounded-[14px] border-[2px] h-[32px] rounded-full px-[4px]">
        <div className="flex min-w-0 flex-1 items-center h-full pl-[12px] pr-[4px] gap-[10px] text-creator-text-sub text-[20px]">
          <div className="my-auto min-w-0 flex-1 font-normal truncate text-[12px]">
            {props.value}
          </div>
          {props.action}
        </div>
      </div>
    </div>
  );
}
